import { render, staticRenderFns } from "./DistributorMain.vue?vue&type=template&id=263607bd"
import script from "./DistributorMain.vue?vue&type=script&lang=js"
export * from "./DistributorMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports